import React, { useEffect, useState } from "react";
import Loading from "../../components/basics/Loading";

export const ExtratoFacilInvite = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const renderComponent = () => {
      try {
        const instance = window.QyonPdf2Ofx({
          access_token: process.env.REACT_APP_EXTRATO_FACIL_TOKEN,
          user_id: null,
          reference_id: null,
          target_list: null,
          primary_color: "#0036b3",
        });

        instance.renderInviteRegistration();
      } catch (e) {
        console.log("retry error");
      }
    };

    let interval = setInterval(() => {
      if (typeof window.QyonPdf2Ofx === "function") {
        clearInterval(interval);
        renderComponent();
        setLoading(false);
      }
    }, 100);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      <Loading open={loading} /> <div id="qyon-pdf2ofx" />
    </>
  );
};
